const AddButton = ({addHandler}) => {
    return (
        <button
            className="add-btn"
            onClick={addHandler}
        >
            +
        </button>
    )
}

export default AddButton